export const SSE_EVENTS = {
  ACCEPTED: 'accepted',
  STATUS: 'status',
  TOKEN: 'token',
  TIMEOUT: 'timeout',
  ERROR: 'error',
  HISTORY: 'history',
} as const;

export const AI_CHAT_EVENTS = {
  SPACES_UPDATE: 'spaces_update',
  MESSAGE_COMPLETE: 'message_complete',
  CONNECTION_STATE_CHANGE: 'connection_state_change',
  ERROR: 'error',
  HISTORY_LOADED: 'history_loaded',
  TURN_ACCEPTED: 'turn_accepted',
} as const;

export const CONNECTION_STATES = {
  DISCONNECTED: 'disconnected',
  CONNECTING: 'connecting',
  CONNECTED: 'connected',
  RECONNECTING: 'reconnecting',
  ERROR: 'error',
} as const;

export const RECONNECT_CONFIG = {
  MAX_ATTEMPTS: 3,
  BASE_DELAY_MS: 1000,
  MAX_DELAY_MS: 30000,
  NO_EVENT_TIMEOUT_MS: 10000,
} as const;

export const SEND_RETRY_CONFIG = {
  MAX_ATTEMPTS: 2,
  NO_RESPONSE_TIMEOUT_MS: 10000,
  RETRY_DELAY_MS: 1000,
} as const;

export const SESSION_STORAGE_KEY = 'ai_chat_session_id';
export const TURN_STORAGE_KEY_PREFIX = 'ai_chat_stream_turn_';

export const ADD_MORE_DETAILS_OPTION = 'Add more details';

export const SPACE_NAMES = {
  STATUS_SUMMARY: 'status_summary',
  STATUS_DETAILS: 'status_details',
  ASSISTANT_MESSAGE: 'assistant_message',
  USER_MESSAGE: 'user_message',
  PLACEHOLDER: 'placeholder',
  BUTTON: 'button',
  BUTTONS: 'buttons',
  PREVIEWS: 'previews',
} as const;

export const DEFAULT_PLACEHOLDER = 'Send a message...';
